export const CLIENT_NOTE_TEMPLATES = {
  standard:
    "Thank you for your business. Please review the invoice details and contact me if you have any questions.",
  payment_reminder:
    "A friendly reminder that payment is due according to the terms shown on this invoice. Please let me know once payment has been sent.",
  project_completion:
    "Thank you for the opportunity to support this project. The work covered by this invoice has been completed as agreed.",
} as const;

export type ClientNoteTemplateKey = keyof typeof CLIENT_NOTE_TEMPLATES;

export const DEFAULT_CLIENT_NOTE_TEMPLATE: ClientNoteTemplateKey = "standard";
export const DEFAULT_CLIENT_NOTE =
  CLIENT_NOTE_TEMPLATES[DEFAULT_CLIENT_NOTE_TEMPLATE];

export const CLIENT_NOTE_TEMPLATE_OPTIONS: Array<{
  value: ClientNoteTemplateKey | "custom";
  label: string;
}> = [
  { value: "standard", label: "Standard thank-you" },
  { value: "payment_reminder", label: "Payment reminder" },
  { value: "project_completion", label: "Project completion" },
  { value: "custom", label: "Custom note" },
];

export function matchingClientNoteTemplate(
  value: string,
): ClientNoteTemplateKey | "custom" {
  const match = Object.entries(CLIENT_NOTE_TEMPLATES).find(
    ([, template]) => template === value,
  );

  return (match?.[0] as ClientNoteTemplateKey | undefined) ?? "custom";
}
